import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin":"auto","display":"table"} }
const _hoisted_2 = { class: "panel" }
const _hoisted_3 = { class: "panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", null, "業務", -1)),
      _createVNode(_component_router_link, {
        to: "/action",
        class: "menubutton btn-primary"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("対応", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/order",
        class: "menubutton btn-primary"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("注文", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[7] || (_cache[7] = _createElementVNode("h3", null, "マスタ", -1)),
      _createVNode(_component_router_link, {
        to: "/master/action",
        class: "menubutton btn-outline-primary"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("対応種類", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/master/noshigami",
        class: "menubutton btn-outline-primary"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("のし紙", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/master/store",
        class: "menubutton btn-outline-primary"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("担当店", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/master/customer",
        class: "menubutton btn-outline-primary"
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode("顧客", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}